export default {
  translation: {
    common: {
      emailOrUsername: 'Имейл или потребителско име',
      invalidEmailOrUsername: 'Невалиден имейл или потребителско име',
      invalidPassword: 'Невалидна парола',
      noInternetConnection: 'Няма интернет връзка',
      pageNotFound_title: 'Страницата не е намерена',
      password: 'Парола',
      projectManagement: 'Управление на проекти',
      serverConnectionFailed: 'Неуспешна връзка със сървъра',
      unknownError: 'Неизвестна грешка, опитайте отново по-късно',
      useSingleSignOn: 'Използване на single sign-on',
    },

    action: {
      logIn: 'Вход',
      logInWithSSO: 'Вход чрез SSO',
    },
  },
};
